export default "__VITE_ASSET__5430a2cd__"